import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

/**
 * Adds the active user language to all outgoing HTTP requests:
 * - Accept-Language: standard HTTP header (e.g. en, ar, ru) so backends and gateways respect it
 * - userLang: custom header for APIs that expect this name
 */
export const userLangInterceptor: HttpInterceptorFn = (req, next) => {
  const transloco = inject(TranslocoService);
  const lang = transloco.getActiveLang() || 'en';
  const cloned = req.clone({
    setHeaders: {
      'Accept-Language': lang,
      userLang: lang,
    },
  });
  return next(cloned);
};
